import { render, staticRenderFns } from "./role_delivery.vue?vue&type=template&id=70832b10&scoped=true&"
import script from "./role_delivery.vue?vue&type=script&lang=js&"
export * from "./role_delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70832b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70832b10')) {
      api.createRecord('70832b10', component.options)
    } else {
      api.reload('70832b10', component.options)
    }
    module.hot.accept("./role_delivery.vue?vue&type=template&id=70832b10&scoped=true&", function () {
      api.rerender('70832b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/roles/row/tabs/role_delivery.vue"
export default component.exports